<template>
  <v-card shaped>
    <v-card-title>
      <v-row class="d-flex align-center justify-space-between">
        <v-col>
          Sessions
        </v-col>
        <v-col>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table
      :headers="computedHeaders"
      :items="computedSessions"
      :search="search"
      :loading="loading"
    >
      <template v-if="showCurriculum" v-slot:item.fields.Curriculum="{ item }" >
        <router-link 
          :to="{ name: 'Curriculum', params: { id: item.fields.Curriculum[0] } }"
        >
        {{ getCurriculumName(item) }}
        </router-link>
      </template>
      <template v-slot:item.fields.Name="{ item }" >
        <router-link 
          :to="{ name: 'Session', params: { id: item.id } }"
        >
        {{ item.fields.Name }}
        </router-link>
      </template>
      <template v-slot:item.fields.Start="{ item }" >
        {{ formatDatetime(item, 'Start') }}
      </template>
      <template v-slot:item.fields.End="{ item }" >
        {{ formatDatetime(item, 'End') }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Table',
    props: {
      loading: Boolean,
      sessions: Array,
      showCurriculum: Boolean
    },
    data () {
      return {
        search: '',
        headers: [
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'fields.Name'
          },
          {
            text: 'Capacity',
            align: 'start',
            sortable: true,
            value: 'capacity'
          },
          {
            text: 'Start',
            align: 'start',
            sortable: true,
            value: 'fields.Start'
          },
          {
            text: 'End',
            align: 'end',
            sortable: true,
            value: 'fields.End'
          }
        ]
      }
    },
    computed: {
      computedSessions () {
        return this.sessions.map(s => {
          s.capacity = s.fields['Attendee Count'] + ' / ' +
                       (s.fields.Capacity || 'No Limit')
          return s
        })
      },
      computedHeaders () {
        const newHeaders = this.headers
        if (this.showCurriculum) {
          newHeaders.unshift({
            text: 'Curriculum',
            align: 'start',
            sortable: true,
            value: 'fields.Curriculum'
          })
          return newHeaders
        } else {
          return this.headers
        }
      }
    },
    created () {
      if (this.showCurriculum && this.$store.getters.getCurriculums.length === 0) {
        this.$store.dispatch('getRecords', {
          table: 'Curriculums',
          view: 'All Curriculums',
          dispatch: 'setCurriculums'
        })
      }
    },
    methods: {
      getCurriculumName (session) {
        const curriculum = this.$store.getters.getCurriculums.find(c => {
          return c.id === session.fields.Curriculum[0]
        })
        if (curriculum) {
          return curriculum.fields.Name
        } else {
          return ''
        }
      },
      formatDatetime (session, field) {
        if (session.fields[field]) {
          const dt = moment(session.fields[field])
          if (dt.hours() === 0 && dt.minutes() === 0) {
            return dt.format("ddd, MMMM Do, YYYY")
          } else {
            return dt.format("ddd, MMMM Do, YYYY h:mma")
          }
        } else {
          return 'TBD'
        }
      },
    }
  }
</script>
